/**
 * @Author: v_jppjpeng
 * @Date: 2025-04-11 17:11:13
 * @Explain: 用户旅程
 */
import { JourneyNodeType } from '@/pages/userJourney/utils/enum/create';

export default {
  'USER.JOURNEY.LIST.TITLE': 'Journey list',
  'USER.JOURNEY.LIST.CONCAT.SENT': 'Number of contacts sent',
  'USER.JOURNEY.LIST.CREATE': 'Create journey',
  'USER.JOURNEY.LIST.CONCAT.START': 'Initiated',
  'USER.JOURNEY.LIST.CONCAT.PROGRESS': 'In progress',
  'USER.JOURNEY.LIST.CONCAT.FINISH': 'Completed',
  'USER.JOURNEY.LIST.STATUS.DRAFT': 'Draft',
  'USER.JOURNEY.LIST.TIP': 'Journeys: Design automated email workflows',
  'USER.JOURNEY.LIST.DES':
    'Set up an automated sending campaign that sends welcome emails to contacts from specific sources when they join the SmartLink contact list,giving them a good first impression.',
  'USER.JOURNEY.LIST.STATUS.NODE.ERROR': 'Ongoing - Journey error',
  'USER.JOURNEY.LIST.STATUS.SUSPENDED.NODE.ERROR': 'Suspended - Journey error',
  'USER.JOURNEY.LIST.DEL.TITLE': 'Delete journey point?',
  'USER.JOURNEY.LIST.DEL.DES':
    'This journey point will be permanently deleted and cannot be restored.',
  'USER.JOURNEY.LIST.CREATE.USER.JOURNEY': 'Create journey',

  'USER.JOURNEY.ADD.SOURCE.BOX.TIP': 'Add a starter',
  'USER.JOURNEY.ADD.SOURCE.BOX.TITLE': 'Select a starter to enter the journey',
  'USER.JOURNEY.ADD.SOURCE.BOX.API.TIP': 'API',
  'USER.JOURNEY.ADD.SOURCE.BOX.API.DES': 'Added by API',
  'USER.JOURNEY.ADD.SOURCE.BOX.FORM.TIP': 'Form',
  'USER.JOURNEY.ADD.SOURCE.BOX.FORM.DES': 'Added by form',
  'USER.JOURNEY.ADD.SOURCE.BOX.TAG.TIP': 'Tag',
  'USER.JOURNEY.ADD.SOURCE.BOX.TAG.DES': 'Tagged',
  // api
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TITLE':
    'Select the API name that added the user',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.CONTENT.TIP':
    'How should the journey be triggered if confirmation is required?',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TYPE.1':
    'Enter journey only after user confirms subscription',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TYPE.1.DES':
    'If subscription confirmation is required, the contact will enter the journey only <b>after the user confirms manually</b> (e.g. by clicking a link). System-based status updates will not trigger the journey.',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TYPE.2':
    'Ignore subscription status, enter journey immediately after contact is added.',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.TYPE.2.DES':
    'Contacts will enter the journey immediately after being added, <b>regardless of subscription status</b>. Make sure this behavior complies with your channel’s rules and consent policy.',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.SELECT': 'Select an API',
  'USER.JOURNEY.ADD.SOURCE.DRAW.API.SEARCH': 'Search API',
  // form
  'USER.JOURNEY.ADD.SOURCE.DRAW.FORM.TITLE':
    'Select the form name that added the user',
  'USER.JOURNEY.ADD.SOURCE.DRAW.FORM.SELECT': 'Select a form',
  'USER.JOURNEY.ADD.SOURCE.DRAW.FORM.SEARCH': 'Search form',
  // tag
  'USER.JOURNEY.ADD.SOURCE.DRAW.TAG.TITLE': 'Select the tag added to a contact',
  'USER.JOURNEY.ADD.SOURCE.DRAW.TAG.SELECT': 'Select a tag',
  'USER.JOURNEY.ADD.SOURCE.DRAW.TAG.SEARCH': 'Search tag',

  // 创建、编辑
  'USER.JOURNEY.EDIT.SAVE.QUIT': 'Save & exit',
  'USER.JOURNEY.EDIT.SAVE.ACTIVATE': 'Save & activate',
  'USER.JOURNEY.SELECT.DEFAULT.TEMPLATE': 'Default template',
  'USER.JOURNEY.SELECT.MARKETING.TEMPLATE': 'Marketing email template',
  'USER.JOURNEY.EDIT.NODE.DELETE.TITLE': 'Delete journey point?',
  'USER.JOURNEY.EDIT.NODE.DELETE.CONTENT':
    'This journey point will be permanently deleted and cannot be restored.',
  'USER.JOURNEY.EDIT.SOURCE.NODE.DELETE.TITLE': 'Delete journey starter？',
  'USER.JOURNEY.EDIT.SOURCE.NODE.DELETE.CONTENT':
    'This journey starter will be permanently deleted and cannot be restored.',
  'USER.JOURNEY.EDIT.NODE.ACTIVE.TITLE': 'Resume Journey',
  'USER.JOURNEY.EDIT.NODE.ACTIVE.CONTENT':
    'This journey will resume and the journey points are executed automatically. Please make sure everything has been set up correctly.',
  'USER.JOURNEY.EDIT.ADD.SOURCE': 'Add source',
  'USER.JOURNEY.EDIT.ADD.JOURNEY.POINT': 'Add journey point',
  'USER.JOURNEY.EDIT.SELECT.JOURNEY.POINT': 'Select journey point',
  'USER.JOURNEY.EDIT.SELECT.CONDITION': 'Condition',
  'USER.JOURNEY.EDIT.SELECT.WAIT.TIME': 'Wait time',
  'USER.JOURNEY.EDIT.SELECT.IF.ELSE': 'If/Else',
  'USER.JOURNEY.EDIT.SELECT.IF.ELSE.NAMED.TIPS':
    'Conditions have been configured',
  'USER.JOURNEY.EDIT.SELECT.IF.ELSE.UNAMED.TIPS': 'Conditions not configured',
  'USER.JOURNEY.EDIT.SELECT.ACTION': 'Action',
  'USER.JOURNEY.EDIT.SELECT.SEND.MAIL': 'Send email',
  'USER.JOURNEY.EDIT.SELECT.SEND.TEST.MAIL': 'Send test email',
  'USER.JOURNEY.UNNAMED.NODE': 'Unnamed journey point',
  'USER.JOURNEY.EDIT.EMAIL.HAVE.SET': 'Send email set up successfully',
  'USER.JOURNEY.EDIT.SET.UP.SUCCESS': 'Set up successfully',
  'USER.JOURNEY.EDIT.EXIT': 'Exit',
  'USER.JOURNEY.WAIT.NUM.REG.TIPS': 'Enter a number (1-100)',
  'USER.JOURNEY.JOURNEY.SOURCE.CITED.ERROR':
    'Sources are cited by other journeys',
  'USER.JOURNEY.PLACEHOLDER.ERROR.1': 'Keys is missing, delivery suspended.',
  'USER.JOURNEY.PLACEHOLDER.ERROR.2': 'The keys are about to run out.',
  'USER.JOURNEY.NODE.ERROR.1':
    'Please check whether the journey nodes have been filled in completely',
  'USER.JOURNEY.NODE.ERROR.2': 'Please check the node information',
  'USER.JOURNEY.NODE.ERROR.3':
    'A template is missing the confirmation link. Please check the template for: {language}',
  'USER.JOURNEY.NODE.ERROR.4':
    'Please check the information of the sending email node. There are duplicate names',
  'USER.JOURNEY.NODE.DELETE.TIPS':
    'This journey point will be permanently deleted and cannot be restored.',
  'USER.JOURNEY.NODE.DELETE.LABEL': 'Keep the paths under this point?',
  'USER.JOURNEY.NODE.DELETE.KEEP.YES': "Keep all 'Yes' paths",
  'USER.JOURNEY.NODE.DELETE.KEEP.NO': "Keep all 'No' paths",
  'USER.JOURNEY.NODE.DELETE.BOTH.PATH': 'Delete both paths',
  'USER.JOURNEY.NODE.SEND.EMAIL.USED.TIPS': 'Used in if/else point',
  'USER.JOURNEY.NODE.DELETE.SUCCEEDED': 'Deleted successfully',
  'USER.JOURNEY.NODE.NAME.DUPLICATED.ERROR': 'Name entered already exists',
  'USER.JOURNEY.EDIT.NOT.ALLOW': 'Journey edited by other users',

  // 分层规则
  'USER.JOURNEY.IF.ELSE.SETTING.TITLE':
    'Create a segment to identify your target audience',
  'USER.JOURNEY.IF.ELSE.DETAILS.TITLE': 'If/Else details',
  'USER.JOURNEY.SEGMENT.RULES': 'Conditional trigger',
  // 旅程统计
  'USER.JOURNEY.POINT.STATISTICS': 'Split statistics',

  // Wait for a trigger
  'USER.JOURNEY.TRIGGER.TITLE': 'Wait for trigger',
  'USER.JOURNEY.TESTER.FILED': 'Tester list attributes',
  'USER.JOURNEY.TRIGGER.TITLE.DETAILS': 'Wait for trigger details',

  // 设置时间限制
  'USER.JOURNEY.TIME.LIMIT.TITLE': 'Forced continuation',
  'USER.JOURNEY.TIME.LIMIT.DESC':
    'If a contact does not meet the condition(s) above within the set time limit, they will automatically advance to the next journey point.',
  'USER.JOURNEY.TIME.LIMIT.WAIT.FOR.LABEL': 'Wait for',

  // 重启弹框文案
  'USER.JOURNEY.RESTART.TITLE': 'Resume journey',
  'USER.JOURNEY.RESTART.TIP.TIME.HOUR': 'Suspended for: <b>{hour}</b> hour(s)',
  'USER.JOURNEY.RESTART.TIP.TIME.DAY.1': 'Suspended for: <b>{day}</b> day(s)',
  'USER.JOURNEY.RESTART.TIP.TIME.DAY.2':
    'Suspended for: <b>{day}</b>day(s) <b>{hour}</b>hour(s)',
  'USER.JOURNEY.RESTART.TIP.CONCAT': 'Accumuated: <b>{num}</b>',
  'USER.JOURNEY.RESTART.DES': 'Resend to accumulated contacts.',
  'USER.JOURNEY.RESTART.SWITCH.TIP': 'Resend immediately',

  'USER.JOURNEY.DETAIL.OPT.DRAWER.TITLE':
    'Second confirmation of subscription and set second subscription rules',

  'USER.JOURNEY.DETAIL.OPT.DRAWER.TITLE.SINGLE':
    'Second confirmation of subscription : Single opt-in',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.TITLE.DOUBLE_PARTICULAR':
    'Second confirmation of subscription : Double opt-in for players from specific regions',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.TITLE.DOUBLE_ALL':
    'Second confirmation of subscription : Double opt-in for players from all regions',
  'USER.JOURNEY.DETAIL.OPT.IN.TIPS1':
    'The double opt-in settings for APIv3 can be found in the Journey.',
  'USER.JOURNEY.DETAIL.OPT.IN.TIPS2':
    'The double opt-in settings for APIv4 can be found in the API Key settings page.',
  'USER.JOURNEY.DETAIL.OPT.IN.TIPS3':
    "The double opt-in settings for Forms can be found on the Form's settings page. The node here does not apply to Forms.",

  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TITLE': 'Resume journey',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP1.1':
    'Suspended for: <span class="mark">{hour}</span> hours',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP1.2':
    'Suspended for: <span class="mark">{day}</span> days',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP1.3':
    'Suspended for: <span class="mark">{day}</span> days <span class="mark">{hour}</span> hours',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP2':
    'Accumuated:<span class="mark">{num}</span> contacts',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP3': 'Resend to accumulated contacts.',
  'USER.JOURNEY.DETAIL.VAR.CONFIRM.TIP4': 'Resend immediately',

  'USER.JOURNEY.DETAIL.OPT.DRAWER.RESTART': 'Resume',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.RESTART.DIS.TIP':
    'Upload more values for the Keys to resume',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.TIP':
    'Keys is missing, delivery suspended',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.NORMAL.1':
    'The Keys has been added and the point can be restarted',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.NORMAL.2':
    'Click the button on the right to restart the point',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.WARN.HOUR.TIP1':
    'Suspended for: <span class="mark">{hour} hours</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.WARN.HOUR.TIP2':
    'Suspended for: <span class="mark">{day} days</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.WARN.HOUR.TIP3':
    'Suspended for: <span class="mark">{day} days</span> <span class="mark">{hour} hours</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.CONCAT.WARN.TIP':
    'Accumuated: <span class="mark">{num} contacts</span>',
  'USER.JOURNEY.DETAIL.OPT.DRAWER.VAR.CONTENT.TIP':
    'Click to upload values for: ',
  'USER.JOURNEY.DETAIL.OPT.PERF.TITLE': 'Performance',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.TITLE': 'Contacts of source',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.ALL': 'All',
  'USER.JOURNEY.DETAIL.OPT.TOTAL.CONTACTS': 'Total number of forms submitted',
  'USER.JOURNEY.DETAIL.OPT.NOT.SEND':
    'Contacts who did not need a confirmation email',
  'USER.JOURNEY.DETAIL.OPT.NODE.CONTACT': 'Contact of point',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.SENDED': 'Sent',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.DELIVER': 'Delivered (Delivery rate)',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.OPENED': 'Opened (Open rate)',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.CLICKED': 'Clicked (Click rate)',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.CONFIRM': 'Confirmed (Confirmation rate)',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.UNSUB': 'Unsubscribed (Unsubscribe rate)',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.NOT.SEND':
    'Sending skipped <b>{notSend}</b> ',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.FAIL.SEND':
    'Sending failed <b>{failSend}</b>',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.FAIL.SEND.INFO':
    'Backlog: <b>{sendBlock}</b> <br>Rebound: <b>{sendBounce}</b>',
  'USER.JOURNEY.DETAIL.OPT.UNDELIVERED': 'Not delivered <b>{undelivered}</b>',
  'USER.JOURNEY.DETAIL.OPT.NO.SEND.TIPS1': 'Skipped due to single opt-in',
  'USER.JOURNEY.DETAIL.OPT.NO.SEND.TIPS2': "Skipped due to contact's region",
  'USER.JOURNEY.DETAIL.OPT.REPEAT.COMMIT.TIPS':
    'Total number of duplicate forms submitted within 1 hour',
  'USER.JOURNEY.DETAIL.OPT.HARD.REBOUND': 'Bounce (hard)',
  'USER.JOURNEY.DETAIL.OPT.QUEUE': 'Backlog',
  'USER.JOURNEY.DETAIL.OPT.SOURCE.EMAIL.FROM': 'From :',
  'USER.JOURNEY.DETAIL.OPT.FILTER': 'Filter',
  'USER.JOURNEY.DETAIL.OPT.NON.DELIVERY': 'Non-delivery',
  'USER.JOURNEY.DETAIL.OPT.NON.DELIVERY.DETAILS': 'Non-delivery Details',

  // 旅程设置
  'USER.JOURNEY.SETTING.TITLE': 'Journey settings',
  'USER.JOURNEY.SETTING.REENTRY.0': 'Contacts can NOT re-enter the journe',
  'USER.JOURNEY.SETTING.REENTRY.1': 'Contasts can re-enter the journey',
  'USER.JOURNEY.SETTING.REENTRY.REENTRY.UNIT.LABEL':
    'Allow contacts to re-enter after',
  'USER.JOURNEY.SETTING.REENTRY.UNIT.MINUTE': 'Minute(s)',

  //  表单未激活
  'USER.JOURNEY.SOURCE.FORM.NOT.ACTIVE':
    'From <span class="mark">{name}</span> is inactive. Contacts who submit this form will not enter the journey',

  // 节点流量控制
  'USER.JOURNEY.FREQUENCY.CONTROL.SWITCH.LABEL':
    'Invitation frequency controls',
  'USER.JOURNEY.FREQUENCY.CONTROL.SWITCH.BUBBLE.DESC':
    'Delivers emails gradually instead of all at once—great for campaigns where timing and pacing matter.',
  'USER.JOURNEY.FREQUENCY.CONTROL.SEND.UP.TO.LABEL': 'Send up to',
  'USER.JOURNEY.FREQUENCY.CONTROL.SEND.UP.TO.AFTER': '',
  'USER.JOURNEY.FREQUENCY.CONTROL.SUBSCRIBERS.PER.LABEL': 'Subscribers per',
  'USER.JOURNEY.FREQUENCY.CONTROL.SPACED.LABEL': 'Spaced',
  'USER.JOURNEY.FREQUENCY.CONTROL.APART.AFTER': 'apart',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.NOT.SET': 'Not set',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.NOT.SET.TIPS':
    'use system default speed',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.1': '1 Minute',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.2': '5 Minutes',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.3': '30 Minutes',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.4': '1 Hour',
  'USER.JOURNEY.FREQUENCY.CONTROL.SENDING.INTERVAL.OPTS.5': '3 Hours',

  'USER.JOURNEY.TEST.EMAIL.LABEL':
    '‌Send multilingual emails to the same mailbox',
  'USER.JOURNEY.TEST.PLACEHOLDER.LABEL': 'Configure keys',

  // 条件节点缩略提示
  'USER.JOURNEY.CONDITION.NODE.TRIGGER.BUTTON': 'Conditions',
  'USER.JOURNEY.CONDITION.NODE.TYPE.TAG': 'Tags',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE': 'Source',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.TIME': 'Time added',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.RANGE': 'Range',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.EQUAL': 'Equal to',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.NOT.EQUAL': 'Not Equal to',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.TIME.DAY': '{day}day{suffix}',
  'USER.JOURNEY.CONDITION.NODE.TYPE.SOURCE.JOIN.CHANNEL':
    'Registration interface',
  'USER.JOURNEY.CONDITION.NODE.TYPE.REGION': 'Region',
  'USER.JOURNEY.CONDITION.NODE.TYPE.LANG': 'Language',
  'USER.JOURNEY.CONDITION.NODE.TYPE.ADD.TIME': 'Add time',
  'USER.JOURNEY.CONDITION.NODE.TYPE.PREFERENCE': 'Preferences',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.TEXT': 'Text type',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.DATE': 'Date type',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.NUMBER': 'Int type',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.OPTIONS': 'Option Type',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.INCLUDE.NONE': 'Include blank values',
  'USER.JOURNEY.CONDITION.NODE.TYPE.FIELD.NOT.INCLUDE.NONE':
    'Exclude blank values',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.CLICK': 'Clicked',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.OPEN': 'opened',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.UNCLICK': 'Not clicked',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.UNOPEN': 'Not opened',

  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.SATISFIED.EVALUATION':
    'Content Rating',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CONCAT.JOIN.SATISFIED.RATE':
    'Content Rating result',
  'USER.JOURNEY.CONDITION.NODE.TYPE.CAMPAIGN': 'Campaigns',
  'USER.JOURNEY.CONDITION.NODE.TYPE.EMAIL.NODE': 'Journey points',

  // 旅程提示
  'USER.JOURNEY.TEST.PLAYER.TIP':
    'Invitation journey. This journey illustrates the automated flow for inviting testers.',
  'USER.JOURNEY.TEST.PLAYER.CONTENT.1':
    '1. Activate journey. A journey needs to be activated first before invitation emails can be sent out to your testers.',
  'USER.JOURNEY.TEST.PLAYER.CONTENT.2':
    "2. Invite testers. After sending out an invitation email to a tester, they will automatically enter this journey and their status will change from 'Waiting' to 'Invited'.",
  'USER.JOURNEY.TEST.PLAYER.CONTENT.3':
    "3. Complete sign-up. The invitation email will contain a link where testers can link their accounts and sign an NDA (can be customized). This will change their status from 'Invited' to 'Accepted'.",
  'USER.JOURNEY.TEST.PLAYER.COPY.LINK.1': 'Copy link',
  'USER.JOURNEY.TEST.PLAYER.COPY.LINK.2':
    'It is essential to include this link in your invitation email template.',
  'USER.JOURNEY.TEST.PLAYER.DISABLED.LINK':
    'Please complete the invitation link configuration first.',
  'USER.JOURNEY.TEST.PLAYER.DISABLE.ADD': 'Cannot add journey point',
  'USER.JOURNEY.TEST.PLAYER.DISABLE.DEL': 'Cannot be deleted',
  'USER.JOURNEY.TEST.PLAYER.SOURCE.TIP': 'Invited testers',
  'USER.JOURNEY.TEST.PLAYER.EMAIL.TIP': 'Invitation email',
  'USER.JOURNEY.TEST.PLAYER.CONDITION.EMAIL.TIP': 'Key email',
  'USER.JOURNEY.NODE.ERROR.NAME.SAME': 'Duplicate node names: {name}',
  // 备注文案 组件相关
  'USER.JOURNEY.DESCRIPTION.INPUT.PLACEHOLDER': 'Description: ',
  'USER.JOURNEY.DESCRIPTION.IS.SHOW': 'Node description',
  'USER.JOURNEY.DESCRIPTION.INPUT.EDIT': 'Edit',
  // 备注 描述默认文案 - 非测试
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.NOT.TESTER.${JourneyNodeType.SOURCE_VALUE}`]:
    'Contacts from this source automatically enter the journey',
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.NOT.TESTER.${JourneyNodeType.WAIT_PERIOD_VALUE}`]:
    'Contacts move to the next node after staying for the set duration',
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.NOT.TESTER.${JourneyNodeType.WAIT_FOR_TRIGGER_VALUE}`]:
    'Contacts move to the next node after meeting the trigger conditions',
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.NOT.TESTER.${JourneyNodeType.IF_ELSE_VALUE}`]:
    'Contacts are automatically routed based on conditions',
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.NOT.TESTER.${JourneyNodeType.SEND_EMAIL_VALUE}`]:
    'Contacts receive a custom email upon reaching this node',

  // 备注 描述默认文案 - 测试
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.TESTER.${JourneyNodeType.SOURCE_VALUE}`]:
    'Invited players enter the journey.',
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.TESTER.Email.${JourneyNodeType.SEND_EMAIL_VALUE}`]:
    'Auto-send invitation email (invitation link required).',
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.TESTER.${JourneyNodeType.WAIT_FOR_TRIGGER_VALUE}`]:
    'Wait for player acceptance.',
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.TESTER.${JourneyNodeType.IF_ELSE_VALUE}`]:
    'Check if the invitation is accepted.',
  [`USER.JOURNEY.DESCRIPTION.DEFAULT.TESTER.KEYS.${JourneyNodeType.SEND_EMAIL_VALUE}`]:
    'Auto-send activation key.',
};
